module.exports = __webpack_public_path__ + "static/media/stadium.20c61bed.png";